<template>
  <fragment>
    <div
      tabindex="-1"
      role="dialog"
      class="modal modal-side-drawer-filters fade fixed-end op"
    >
      <div
        role="document"
        class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title">Advanced Search</h2>
            <button
              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true"><i class="far fa-times"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="data-filters">
              <div class="row">
                <div class="col-12 col-lg-6">
                  <label>Dependency</label>
                  <div class="input-group">
                    <span class="input-group-text">
                      <i class="fal fa-search"></i>
                    </span>
                    <input
                      type="text"
                      class="form-control"
                      :value="filters.search"
                      @input="updateSearch"
                    />
                  </div>
                </div>
                <div class="col-6 col-lg-3">
                  <label>Platform</label>
                  <div class="input-group">
                    <span class="input-group-text">
                      <i class="fal fa-layer-group"></i>
                    </span>

                    <multiselect
                      label="label"
                      :options="platformOptions"
                      :show-labels="false"
                      placeholder
                      v-model="platformSelected"
                      track-by="value"
                    />
                  </div>
                </div>
                <div class="col-6 col-lg-3">
                  <label>Branch</label>
                  <div class="input-group">
                    <span class="input-group-text">
                      <i class="fal fa-code-branch"></i>
                    </span>

                    <select-branch v-model="filters.branch"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12 col-lg-4">
        <ul class="list-data no-links no-hover mt-0">
          <severity-checkbox
            v-model="filters.severity"
            severity="critical"
            :count="severityCounts.critical"
          />
          <severity-checkbox
            v-model="filters.severity"
            severity="high"
            :count="severityCounts.high"
          />
          <severity-checkbox
            v-model="filters.severity"
            severity="moderate"
            :count="severityCounts.moderate"
          />
          <severity-checkbox
            v-model="filters.severity"
            severity="low"
            :count="severityCounts.low"
          />
        </ul>
      </div>
      <div class="col-12 col-lg-8">
        <div class="alert alert-success flex-column" v-if="noVulnerabilities && !fetching">
          <h4>Yay, no vulnerabilities!</h4>

          <p>At least there's none that we are aware of. Maybe go write a test or two.</p>
        </div>
        <div class="alert alert-info flex-column" v-else-if="vulnerabilities.length === 0 && !fetching">
          <h4>No Vulnerabilities Found</h4>

          <p>Try adjusting your search or including other severities.</p>
        </div>
        <vulnerability-card v-else v-for="vulnerability in vulnerabilities" :key="vulnerability.id" v-bind="{ vulnerability }"/>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { debounce, isEqual } from 'lodash'
import { appliesFilters } from '@/mixins'
import Multiselect from 'vue-multiselect'
import SeverityCheckbox from './SeverityCheckbox'
import SelectBranch from './SelectBranch'
import VulnerabilityCard from './VulnerabilityCard'

export default {
  mixins: [appliesFilters],

  components: {
    Multiselect,
    SeverityCheckbox,
    VulnerabilityCard,
    SelectBranch
  },

  data () {
    return {
      fetching: false,
      filtersDebounced: false,
      filters: {
        search: null,
        platform: null,
        branch: 'staging',
        severity: ['critical', 'high', 'moderate', 'low']
      },
      platformOptions: [
        { value: null, label: 'All' },
        { value: 'packagist', label: 'Packagist (PHP)' },
        { value: 'npm', label: 'NPM' }
      ]
    }
  },

  computed: {
    ...mapState('applications', {
      application: 'single'
    }),
    ...mapState('applications/vulnerabilities', ['vulnerabilities', 'severityCounts']),

    noVulnerabilities () {
      return Object.values(this.severityCounts).reduce((count, value) => count + value, 0) === 0
    },

    platformSelected: {
      get () {
        return this.platformOptions.find(({ value }) => value === this.filters.platform)
      },

      set ({ value }) {
        this.filters.platform = value
      }
    }
  },

  watch: {
    queryParams: {
      async handler (params, oldParams) {
        if (isEqual(params, oldParams)) {
          return
        }

        this.fetching = true

        await this.getVulnerabilities(params)

        this.fetching = false
      },
      immediate: true
    }
  },

  beforeDestroy () {
    this.resetVulnerabilities()
  },

  methods: {
    ...mapActions('applications/vulnerabilities', ['getVulnerabilities', 'resetVulnerabilities']),

    updateSearch: debounce(function (event) {
      this.filters.search = event.target.value
    }, 750)
  }
}
</script>
